import { render, staticRenderFns } from "./NewSigner.vue?vue&type=template&id=7c0c526f"
import script from "./NewSigner.vue?vue&type=script&lang=js"
export * from "./NewSigner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports